import { render, staticRenderFns } from "./mobile-header-foot.vue?vue&type=template&id=d996f116&scoped=true"
import script from "./mobile-header-foot.vue?vue&type=script&lang=js"
export * from "./mobile-header-foot.vue?vue&type=script&lang=js"
import style0 from "./mobile-header-foot.vue?vue&type=style&index=0&id=d996f116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d996f116",
  null
  
)

export default component.exports